import { styled } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useEffect, useState } from 'react';

import BlurryLoadingImage from '@/components/progressive-img';

import styles from './styles.module.less';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800]
    })
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8'
    })
  }
}));
const Loading = () => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prevProgress => (prevProgress >= 90 ? 95 : prevProgress + 10));
    }, 400);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.img}>
        <BlurryLoadingImage src={(window?.imgPrefix || '') + (window?.privateConfig?.logo || '/img/BIG_LOGO.webp')} />
      </div>
      <div className={styles.title}>
        <div>Slots / Casino for real money</div>
        <div>Over 5,200,000+ players in the USA</div>
      </div>
      <BorderLinearProgress className={styles.LinearProgress} variant="determinate" value={progress} />
    </div>
  );
};

export default Loading;
